module.exports = __webpack_public_path__ + "static/img/ZimScape-02.3d3dd79a.png";